import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';

dayjs.locale('zh-cn');

export function formatDate(date: string | Date | undefined, format = 'YYYY-MM-DD HH:mm'): string {
  if (!date) return '-';
  return dayjs(date).format(format);
}

export function formatTicketNo(ticketNo: string): string {
  return ticketNo;
}

export function getStatusText(status: string): string {
  const map: Record<string, string> = {
    pending: '待整改',
    rectified: '已整改',
    verified: '已验收',
    closed: '已关闭',
  };
  return map[status] || status;
}

export function getLevelText(level: string): string {
  const map: Record<string, string> = {
    red: '红警',
    yellow: '黄警',
  };
  return map[level] || level;
}

export function getRoleText(role: string): string {
  const map: Record<string, string> = {
    inspector: '巡检员',
    responder: '责任人',
    admin: '管理员',
  };
  return map[role] || role;
}
